import styled, { css } from 'styled-components';

export const ApiContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;

  :first-child {
    padding-top: 10px;
  }
`;

export const APIAndDescriptionContainer = styled.div`
  padding: 5px 10px;
  font-weight: 400;
`;

export const ApiDescription = styled.p`
  padding: 10px;
  white-space: pre-wrap;
  margin-bottom: 0px;
  background: ${({ theme }) => theme.freecode.headerBackground};
  color: ${({ theme }) => theme.freecode.color};
  border-width: 0px 1px 1px 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
  border-color: ${({ theme }) => theme.freecode.headerDropShadow};
  font-size: 15px;
`;

export const ApiDescriptionContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.freecode.headerDropShadow};
`;

export const ExpandingListItemHeader = styled.span`
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  background: ${({ theme }) => theme.freecode.headerBackground};
  color: ${({ theme }) => theme.freecode.color};
  border: 1px solid ${({ theme }) => theme.freecode.headerDropShadow};
  letter-spacing: 1px;

  :hover {
    color: ${({ theme }) => theme.freecode.colorHover};
    background: ${({ theme }) => theme.freecode.buttonBackgroundHover};
  }

  ${({ canOpen }) =>
    canOpen &&
    css`
      cursor: pointer;
      :hover {
        background: ${({ theme }) => theme.freecode.buttonBackgroundHover};
      }
    `}

  ${({ isOpen }) =>
    isOpen &&
    css`
      border-radius: 10px 10px 0 0;
    `}
`;

export const ExpandIcon = styled.i.attrs(({ icon }) => ({
  className: icon,
}))`
  color: ${({ theme }) => theme.freecode.color};
  margin-right: 5px;

  :hover {
    color: ${({ theme }) => theme.freecode.colorHover};
  }
`;
